import { Injectable } from '@angular/core';
import { AnalyticsAdjustPagesModel } from './analytics-adjust-pages-models';
import { JourneyService } from '../journey/journey.service';
import { TrackTypes } from '../journey/tracks/model/track-types';
import { TrackAdjustNativeService } from '../comunicator-native/track-adjust-native/track-adjust-native';
import { ParamDefaultAdjust } from '../comunicator-native/track-adjust-native/itrack-adjust-native';

@Injectable({
    providedIn: 'root'
})

export class AnalyticsAdjustPageService {


    constructor(
        private journeyService: JourneyService,
        private trackAdjustNativeService: TrackAdjustNativeService
    ) {

    }

    public setAnalyticsPageAdjust(): AnalyticsAdjustPagesModel {

        const journey = this.journeyService.journey;
        const analyticsPageAdjust: AnalyticsAdjustPagesModel = new AnalyticsAdjustPagesModel();

        switch (journey) {
            case TrackTypes.CONTA_ION:
                this.setContaIonGA4Common(analyticsPageAdjust);
                this.setContaIonGA4Personal(analyticsPageAdjust);
                this.setContaIonGA4Income(analyticsPageAdjust);
                return analyticsPageAdjust;
            case TrackTypes.CONTA_ION_PERSONAL:
                this.setContaIonGA4Common(analyticsPageAdjust);
                this.setContaIonGA4Personal(analyticsPageAdjust);
                return analyticsPageAdjust;
            case TrackTypes.CONTA_ION_MARITAL:
                this.setContaIonGA4Common(analyticsPageAdjust);
                return analyticsPageAdjust;
            case TrackTypes.CONTA_ION_ADDRESS:
                this.setContaIonGA4Common(analyticsPageAdjust);
                return analyticsPageAdjust;
            case TrackTypes.CONTA_ION_PROFESSIONAL:
                this.setContaIonGA4Common(analyticsPageAdjust);
                this.setContaIonGA4Income(analyticsPageAdjust);
                return analyticsPageAdjust;
            case TrackTypes.CONTA_ION_INCOME:
                this.setContaIonGA4Common(analyticsPageAdjust);
                this.setContaIonGA4Income(analyticsPageAdjust);
                return analyticsPageAdjust;
            default:
                return analyticsPageAdjust;
        }
    }

    public sendTrackAdjust(paramDefautl: ParamDefaultAdjust) {

        if (Object.values(paramDefautl).every(val => val === '')) {
            return;
        }

        return this.trackAdjustNativeService.trackAdjust(paramDefautl)
    }

   
    //Conta-ion
    private setContaIonGA4Common(analyticsPageAdjust: AnalyticsAdjustPagesModel) {
        analyticsPageAdjust.criarconta_perfil_tudocerto = 'fwvtqw';
    }

    private setContaIonGA4Personal(analyticsPageAdjust: AnalyticsAdjustPagesModel) {
        analyticsPageAdjust.criarconta_dados_documento_numero = '20x3qk';
        analyticsPageAdjust.criarconta_dados_documento = '34ck0v';
    }

    private setContaIonGA4Income(analyticsPageAdjust: AnalyticsAdjustPagesModel) {
        analyticsPageAdjust.criarconta_renda_residenciafiscal = '3kgupi';
    }

}
